import React from 'react';

export const PageNotFound = () => {
    return <div className="wrapper">Сторінку не знайдено!</div>;
};

export default PageNotFound;
